import { ProductModule } from '@/hooks/organization-config/useOrganizationEnabledModules';
import paths from '@/paths';
import { createRoute, Outlet, redirect } from '@tanstack/react-router';
import { Route as rootRoute } from 'src/pages/__root';

export const MODULE_TO_HOME_PAGE: Record<ProductModule, string> = {
  [ProductModule.ORDER_MANAGEMENT]: paths.authenticated.salesOrders,
  [ProductModule.REBATES]: paths.authenticated.rebates.uploadData,
  [ProductModule.PROCUREMENT]: paths.authenticated.procurement.suppliers,
  [ProductModule.FAMOUS_INTEGRATION]: paths.authenticated.famousEDI,
  [ProductModule.ORDERFUL_EDI]: paths.authenticated.famousEDI,
  [ProductModule.SHIP_AND_DEBIT]: paths.authenticated.shipAndDebit.dashboard,
  [ProductModule.AP_INVOICING]: paths.authenticated.accountsReceivable.invoices,
  [ProductModule.ORACLE_EBS_INTEGRATION]: paths.authenticated.salesOrders,
  [ProductModule.PROCUREMENT_DEMO]:
    paths.authenticated.procurementDemo.dashboard,
};

export const Route = createRoute({
  path: '/',
  getParentRoute: () => rootRoute,
  beforeLoad: async (ctx) => {
    const { auth } = ctx.context;
    if (auth.isFetchingAuthInitialStatus) {
      return true;
    }

    if (auth.currentUser) {
      throw redirect({ to: paths.authenticated.home });
    } else {
      throw redirect({
        to: '/login',
        search: {
          redirect: ctx.location.href,
        },
      });
    }
  },
  component: () => <Outlet />,
});
